import React,{ useState, useEffect } from 'react'

const CartCountBadge = (): React.ReactElement | null => {
  const [cartItemCount, SetCartCount] = useState(0);
  useEffect(() => {
    fetch('/cart.json')
      .then(response => response.json())
      .then(data => {
        SetCartCount(data.item_count);
      });
  }, []);
  return <div className="cart-count-badge">{cartItemCount}</div>
};

export default CartCountBadge